<template lang="pug">
div.preview-element.border-map-cirlce(:style="wrapStyle")
	slot
</template>

<script>
import {computed} from "vue";
import ParseSpecifications from "@/commons/ParseSpecifications";
import {PreviewHelper} from "@/preview/PreviewHelper";

export default {
	name: "BorderMapCircle",
	props: {
		selectedItems: {
			type: Object,
			default() {
				return {}
			}
		},

		dimensions: {
			type: Object,
			default() {
				return {}
			}
		},

		spec: {
			type: Object,
			default() {
				return {}
			}
		},

		borderColor: {
			type: String,
			default: ""
		}
	},

	setup(props) {

		const specShape = computed(() =>{
			var s = props.spec.star_map;
			if (props.spec.star_map_shape && props.spec.star_map_shape.top > 0) {
				s = props.spec.star_map_shape
			}
			return s;
		});

		const wrapStyle = computed(() => {
			const { textColor } = PreviewHelper(props);
			var output =  '';
			output = `
			top: ${specShape.value.top}%;
			left: ${specShape.value.left}%;
			width: ${props.spec.star_map.width / 100 * window.nse_app.poster_px.value.width}px;
			height: ${props.spec.star_map.height / 100 * window.nse_app.poster_px.value.height}px;
			border: ${props.spec.star_map.line / 100 * window.nse_app.poster_px.value.width}px solid ${textColor.value};
			`;
			return output;
		})

		return {
			wrapStyle,
			specShape
		}
	}
}
</script>

<style lang="scss">
	.preview-element {
		&.border-map-cirlce{
			position: absolute;
			margin: auto;
			left: 0;
			top: 0;
			border-radius: 50%;
		}
	}
</style>
